import React from 'react';
import { Box } from 'components/Box';
import { Text } from 'components/Text';
import { RadioList, RadioListItem } from 'components/RadioList';

export type SpaceType = 'FTL' | 'LTL';

type SpaceProps = {
  value?: SpaceType;
  onChange?: (space: SpaceType) => void;
};

const Space = (props: SpaceProps) => {
  const { value, onChange = () => {} } = props;

  function handleChange(
    event: React.ChangeEvent<React.ElementRef<typeof RadioListItem>>
  ) {
    const radio = event.currentTarget as HTMLInputElement;
    onChange(radio.value as SpaceType);
  }

  return (
    <RadioList direction="row" margin={[0, 0, 'medium']}>
      <RadioListItem name="space" value="FTL" required onChange={handleChange}>
        <TruckImage type="FTL" selected={value === 'FTL'} />
        <Text weight="medium">Full truckload (FTL)</Text>
      </RadioListItem>
      <RadioListItem name="space" value="LTL" required onChange={handleChange}>
        <TruckImage type="LTL" selected={value === 'LTL'} />
        <Text weight="medium">Less than truckload (LTL)</Text>
      </RadioListItem>
    </RadioList>
  );
};

type TruckImageProps = {
  type: SpaceType;
  selected: boolean;
};

const TruckImage = ({ type, selected }: TruckImageProps) => {
  const image = selected ? `${type}-selected.png` : `${type}-default.png`;

  return (
    <Box
      as="img"
      src={`/assets/${image}`}
      width="180"
      height="110"
      margin={[0, 0, 'medium']}
    />
  );
};

export { Space };
